import { createFormattersObject } from "../../helpers/utils";
import type { CDMInfo } from "../../services/conjunctions";
import { useAvailableconjunctionHeaders } from "../../services/configuration";
import { FullscreenPanelCard } from "../FullscreenPanelCard";
import { useFullscreenPanel } from "../useFullscreenPanel";
import { CDMContainer } from "../../containers/CDMContainer";
import { ConjunctionFallback3DView } from "./ConjunctionFallback3DView";
import { ConjunctionSummaryCard } from "./ConjunctionSummaryCard";
import type { ConjunctionRiskConfig } from "./conjunctionUiUtils";

interface Conjunction3DPanelProps {
  cdm?: CDMInfo | null;
  conjunction: unknown;
  riskConfig?: ConjunctionRiskConfig;
}

export const Conjunction3DPanel = ({
  cdm,
  conjunction,
  riskConfig,
}: Conjunction3DPanelProps) => {
  const availableConjHeaders = useAvailableconjunctionHeaders();
  const formatters = createFormattersObject(availableConjHeaders.value);
  const { isFullscreen, toggleFullscreen } = useFullscreenPanel();

  return (
    <div className="flex h-full w-full min-h-0 overflow-hidden bg-slate-50/40 p-5 !pt-1">
      <section className="flex h-full min-h-0 w-full flex-col gap-5">
        {!isFullscreen && (
          <ConjunctionSummaryCard
            className="shrink-0"
            conjunction={conjunction}
            formatters={formatters}
            riskConfig={riskConfig}
          />
        )}

        <FullscreenPanelCard
          badge={cdm?.id ? "CDM available" : "Keplerian fallback"}
          fullscreenLabel="3D"
          isFullscreen={isFullscreen}
          onToggleFullscreen={toggleFullscreen}
          subtitle="CDM visualization and source XML."
          title="3D View"
        >
          <CDMContainer
            cdm={cdm}
            fallback={<ConjunctionFallback3DView conjunction={conjunction} />}
          />
        </FullscreenPanelCard>
      </section>
    </div>
  );
};
